import * as signalR from '@microsoft/signalr'

class BroadcastService {
  constructor() {
    this.connection = null
    this.connected = false
    this.joinedMeetings = new Set()
  }

async connect(meetingIds = []) {
  if (this.connected && this.connection) {
    console.log('[Broadcast] Already connected.');
    return;
  }

  const baseUrl = "https://webhook.diab.com.vn";
  const hubUrl = `${baseUrl}/zoom/broadcast/meeting`;

  console.log('[BroadcastService] Connecting to:', hubUrl);

  this.connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl)
    .configureLogging(signalR.LogLevel.Information)
    .build();

  this.connection.onclose(() => {
    this.connected = false;
    console.warn('[Broadcast] ❌ Disconnected');
  });

  await this.connection.start();
  this.connected = true;
  console.log('[Broadcast] ✅ Connection established');

  // ✅ Only join groups if any are provided
  if (meetingIds.length > 0) {
    for (const id of meetingIds) {
      await this.joinMeeting(String(id));
    }
  }
}

  async joinMeeting(meetingId) {
    console.group(`[BroadcastService] joinMeeting → ${meetingId}`)

    if (!this.connection || !this.connected) {
      console.warn('⚠️ Connection not ready yet')
      console.groupEnd()
      return
    }

    if (this.joinedMeetings.has(meetingId)) {
      console.log('ℹ️ Already joined:', meetingId)
      console.groupEnd()
      return
    }

    try {
      console.log('➡️ Sending JoinMeetingGroup...')
      await this.connection.invoke('JoinMeetingGroup', String(meetingId))
      this.joinedMeetings.add(meetingId)
      console.log('✅ Joined meeting group:', meetingId)
    } catch (err) {
      console.error(`[Broadcast] ❌ Failed to join group ${meetingId}:`, err)
    }

    console.groupEnd()
  }

  on(event, callback) {
    if (!this.connection) {
      console.warn('[Broadcast] ⚠️ Not connected yet — cannot register listener')
      return
    }
    console.log(`[Broadcast] 👂 Listening for event: ${event}`)
    this.connection.on(event, callback)
  }

  async disconnect() {
    console.group('[BroadcastService] disconnect')
    if (this.connection) {
      await this.connection.stop()
      console.log('[Broadcast] 🚪 Connection stopped')
      this.connection = null
      this.connected = false
      this.joinedMeetings.clear()
    } else {
      console.log('ℹ️ No active connection to stop')
    }
    console.groupEnd()
  }
}

export default BroadcastService
